// import { Container } from "@mui/material";
import React from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
// import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
// import MenuIcon from "@mui/icons-material/Menu";
import LiveHelpIcon from "@mui/icons-material/LiveHelp";
// import Box from '@mui/material/Box';
import Avatar from "@mui/material/Avatar";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import Divider from "@mui/material/Divider";
import Settings from "@mui/icons-material/Settings";
import TelegramIcon from "@mui/icons-material/Telegram";

// import IconButton from '@mui/material/IconButton';
// import Typography from '@mui/material/Typography';
import Tooltip from "@mui/material/Tooltip";
// import PersonAdd from "@mui/icons-material/PersonAdd";
// import Settings from "@mui/icons-material/Settings";
// import Logout from "@mui/icons-material/Logout";
import FacebookRoundedIcon from "@mui/icons-material/FacebookRounded";
import { Link } from "@mui/material";

const PhysicsAdmissionHeader = () => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  return (
    <Box sx={{ flexGrow: 1, width: "100%", mb: 10 }}>
      <AppBar position="fixed">
        <Toolbar>
          <Link
            href="https://www.facebook.com/groups/physics.of.stupid/posts/600429177887380"
            underline="hover"
          >
            <IconButton
              size="large"
              edge="start"
              color="inherit"
              aria-label="menu"
              sx={{ mr: 2 }}
            >
              <Avatar
                className="App-logo"
                alt="Physics Of Stupid"
                src="https://i.ibb.co/8715hrP/191050242-111743741133047-6880428638969503664-n.jpg"
              />
            </IconButton>
          </Link>

          <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
            Physics Admission Batch
          </Typography>
          <Box
            sx={{ display: "flex", alignItems: "center", textAlign: "center" }}
          >
            <Tooltip title="WebApp Assists">
              <IconButton onClick={handleClick} size="small" sx={{ ml: 2 }}>
                <Avatar sx={{ width: 32, height: 32 }}>
                  <Settings fontSize="small" />
                </Avatar>
              </IconButton>
            </Tooltip>
          </Box>
          <Menu
            sx={{
              background: "#0a1929",
              transition: "background-image 0.5s linear",
              opacity: "90%",
            }}
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            onClick={handleClose}
            PaperProps={{
              elevation: 0,
              sx: {
                overflow: "visible",
                filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
                mt: 1.5,
                "& .MuiAvatar-root": {
                  width: 32,
                  height: 32,
                  ml: -0.5,
                  mr: 1,
                },
                "&:before": {
                  content: '""',
                  display: "block",
                  position: "absolute",
                  top: 0,
                  right: 14,
                  width: 10,
                  height: 10,
                  bgcolor: "background.paper",
                  transform: "translateY(-50%) rotate(45deg)",
                  zIndex: 0,
                },
              },
            }}
            transformOrigin={{ horizontal: "right", vertical: "top" }}
            anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
          >
            <Link
              href="https://www.facebook.com/groups/physicsadmissionbatch"
              target="_blank"
              underline="none"
            >
              <MenuItem>
                <Avatar sx={{ width: 32, height: 32 }}>
                  <FacebookRoundedIcon fontSize="medium" />
                </Avatar>
                Facebook Group
              </MenuItem>
            </Link>
            <Link
              href="https://www.facebook.com/groups/physicsadmissionbatch"
              target="_blank"
              underline="none"
            >
              <MenuItem>
                <Avatar sx={{ width: 32, height: 32 }}>
                  <TelegramIcon fontSize="medium" />
                </Avatar>
                Telegram Forum
              </MenuItem>
            </Link>

            <Divider />
            <Link
              href="https://m.me/PhysicsofStupid"
              target="_blank"
              underline="none"
            >
              <MenuItem>
                <ListItemIcon>
                  <LiveHelpIcon fontSize="small" />
                </ListItemIcon>
                Live Support
              </MenuItem>
            </Link>
            <Link
              href="https://www.facebook.com/groups/physics.of.stupid"
              target="_blank"
              underline="none"
            >
              <MenuItem>
                <ListItemIcon>
                  <Settings fontSize="small" />
                </ListItemIcon>
                Public Group
              </MenuItem>
            </Link>
          </Menu>
        </Toolbar>
      </AppBar>
    </Box>
  );
};

export default PhysicsAdmissionHeader;
